/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-system-service.ts
 *
 * Created by kyang on 2020-09-10.
 */

function FileSystemServiceConstructor (
    this: JS5Object,
    _: JS5Object,
    FileSystemResourceFactory: JS5Object,
    PaginationService: JS5Object,
) {
    const updatePagination = (data: JS5Object, responseHeaders: JS5Function) => {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };

    this.getFileSystems = (criteria: JS5Object) => {
        let firstIndex = _.get(criteria, 'fetchOffset', 0);
        let lastIndex = firstIndex + _.get(criteria, 'fetchLimit', 25) - 1;
        let finalCriteria = _.omit(criteria, ['fetchOffset', 'fetchLimit', 'searchString']);
        finalCriteria.range = `storagefilesystems ${firstIndex}-${lastIndex}`;
        finalCriteria.name = _.get(criteria, 'searchString');
        return FileSystemResourceFactory.query(finalCriteria, updatePagination).$promise;
    };

    this.getFileSystem = (id: string) => {
        return FileSystemResourceFactory.getFileSystem({id: id}).$promise;
    }

    this.createFileSystem = (fileSystem: JS5Object) => {
        return FileSystemResourceFactory.createFileSystem(fileSystem).$promise;
    }

    this.updateFileSystem = (fileSystem: JS5Object) => {
        return FileSystemResourceFactory.updateFileSystem(fileSystem).$promise;
    }

    this.getFileSystemTypes = () => {
        return FileSystemResourceFactory.getFileSystemTypes({range: 'storagefilesystemstype 0-1000000'}).$promise;
    }
}

angular
    .module('prism-ui.fileSystem')
    .service(
        'FileSystemService',
        FileSystemServiceConstructor
    );
